var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMpIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1081_10362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1827 0.709H11.4843C5.60253 0.709 0.833496 5.0355 0.833496 10.9464V11.1031C0.833496 17.0109 5.60253 21.3405 11.4843 21.3405L16.3335 21.3405C18.0258 22.7419 20.2906 23.871 22.3277 24.6875C22.5845 24.7858 22.8322 24.5217 22.6854 24.3037C22.1076 23.4592 21.2241 21.9546 21.1355 20.5759C25.0577 19.0007 27.8304 15.6077 27.8304 11.1031V10.9464C27.8304 5.0355 23.0645 0.709 17.1827 0.709Z",
    fill: "#00C18A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.18291 12.9178C9.05411 12.9178 9.76036 12.2084 9.76036 11.3333C9.76036 10.4583 9.05411 9.7489 8.18291 9.7489C7.31172 9.7489 6.60547 10.4583 6.60547 11.3333C6.60547 12.2084 7.31172 12.9178 8.18291 12.9178Z",
    fill: "#A6F4C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3333 12.9178C15.2045 12.9178 15.9108 12.2084 15.9108 11.3333C15.9108 10.4583 15.2045 9.7489 14.3333 9.7489C13.4621 9.7489 12.7559 10.4583 12.7559 11.3333C12.7559 12.2084 13.4621 12.9178 14.3333 12.9178Z",
    fill: "#A6F4C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4813 12.9178C21.3525 12.9178 22.0587 12.2084 22.0587 11.3333C22.0587 10.4583 21.3525 9.7489 20.4813 9.7489C19.6101 9.7489 18.9038 10.4583 18.9038 11.3333C18.9038 12.2084 19.6101 12.9178 20.4813 12.9178Z",
    fill: "#A6F4C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1081_10362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 24,
    fill: "white",
    transform: "translate(0.833496 0.708984)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMpIcon2);
export default __webpack_public_path__ + "static/media/mpIcon2.538f09eb3e32bfbb4d5d385c030b5b7f.svg";
export { ForwardRef as ReactComponent };